import { useEffect, useState } from "react";
import ZohoForm from "./ZohoForm";
import { useTranslation } from "react-i18next";

export const LeadForm = () => {
   const { t } = useTranslation();
  // const [htmlContent, setHtmlContent] = useState("");
  // useEffect(() => {
  //   fetch("/zoho_form1.html")
  //     .then((res) => res.text())
  //     .then((data) => setHtmlContent(data));
  // }, []);
  return (
    <div className="w-full">
      <h3 className="text-xl sm:text-2xl font-bold text-foreground mb-2 px-4 sm:px-8 pt-3">
        {t("Claim Your Free Setup & Retailer Offers")}
      </h3>
      <p className="text-muted-foreground mb-4 md:mb-6 text-xs sm:text-sm px-4 sm:px-8">
        {t("Join 250+ Egyptian stores already growing their business")}
      </p>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
        }}
      >
        {/* <ZohoForm /> */}
        {/* <div dangerouslySetInnerHTML={{ __html: htmlContent }} /> */}
        {/* <iframe
          src="/zoho_form1.html"
          title="HTML View"
          width="100%"
          height="800"
          style={{ border: "none" }}
        /> */}
        <iframe
          src="https://crm.zoho.com/crm/WebFormServeServlet?rid=fdf424ec82e2400ed70107fff13246c1cd27a1d2be0ce62cd7f8a17789c66f32c6eb1bdad4569570744b1461c7adfe35gid6a1af47951c39becbe9fadf126b47865c04a7648500a721fb89f1703309a5ecc"
          title="Zoho Form"
          className="md:w-[610px] md:h-[364px] w-[305px] h-[470px]"
        ></iframe>
      </div>
    </div>
  );
};
